import { useEffect, useState } from 'react'

import { ApiError, api } from '../api'
import type { ChapterResponse } from '../../contracts/api'
import { useNav } from '../nav'
import './chapter.css'

/**
 * Одна глава портрета: раскрытие по одной странице, как и обещано в знакомстве.
 * Системную стрелку «назад» ставит App — здесь только её дубль в шапке.
 */
export function Chapter({ id, title }: { id: string; title: string }) {
  const [data, setData] = useState<ChapterResponse | null>(null)
  const [error, setError] = useState('')
  const { back } = useNav()

  useEffect(() => {
    let cancelled = false
    api
      .get<ChapterResponse>(`/api/chapters/${id}`)
      .then((result) => {
        if (!cancelled) setData(result)
      })
      .catch((cause: unknown) => {
        if (!cancelled) setError(cause instanceof ApiError ? cause.message : 'Глава не открылась')
      })
    return () => {
      cancelled = true
    }
  }, [id])

  return (
    <div className="screen chapter">
      <div className="topbar">
        <div className="brand">АТЛАС</div>
        <div className="topnote">глава</div>
      </div>
      <button type="button" className="back" onClick={back}>
        <svg width="14" height="14" viewBox="0 0 14 14">
          <path d="M9 2 4 7l5 5" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        ПОРТРЕТ
      </button>

      <h1 className="display">{data?.title ?? title}</h1>

      {error && <div className="state">{error}</div>}
      {!data && !error && <div className="state">Читаем эту часть карты…</div>}

      {data && (
        <>
          <div className="chapter-lead">{data.lead}</div>
          {data.body.map((paragraph) => (
            <p className="chapter-body" key={paragraph.slice(0, 24)}>
              {paragraph}
            </p>
          ))}
          <div className="card chapter-practice">
            <div className="lbl" style={{ color: 'var(--gold)' }}>
              Что с этим делать
            </div>
            <p>{data.practice}</p>
          </div>
        </>
      )}
    </div>
  )
}
